import type { z } from 'zod';

import { indexSearchSchema, listParams } from '@nucleus-commerce/admin-kit/index-table';

import type { CustomerListParams } from '../api/customers-api';
import { CUSTOMER_FILTER_FIELDS, CUSTOMER_SORTS } from '../components/customer-filters';

/** URL search params of the customers list; mirrors GET /admin/v1/stores/{storeId}/customers. */
export const customerListSearchSchema = indexSearchSchema(CUSTOMER_FILTER_FIELDS, {
  sort: CUSTOMER_SORTS,
});

export type CustomerListSearch = z.infer<typeof customerListSearchSchema>;

/** The list request for a validated search; the page's `useSearchListState().params` match it. */
export function customerListParams(search: CustomerListSearch): CustomerListParams {
  return listParams(search, CUSTOMER_FILTER_FIELDS);
}
